import "./index.css";

const SearchBar = ({
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  categories
}) => {
  return (
    <div className="searchbar-wrapper">

      <input
        className="search-input"
        placeholder="Search transactions..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <select
        className="category-select"
        value={selectedCategory}
        onChange={(e) => setSelectedCategory(e.target.value)}
      >
        <option value="All">All</option>
        {categories.map(c => (
          <option key={c.name} value={c.name}>
            {c.name}
          </option>
        ))}
      </select>

    </div>
  );
};

export default SearchBar;
